import { pageFormValidation } from "Validation";

/**
 * Finds the step name in a stepFieldsMap that contains the given error field.
 *
 * @param {string} errorField - The name of the field with a validation error.
 * @param {Object} stepFieldsMap - An object mapping step names to arrays of field names.
 * @returns {string|null} The step name containing the error field, or null if not found.
 */
export const lookupStepForError = (errorField, stepFieldsMap) => {
  return (
    Object.entries(stepFieldsMap).find(([_, fields]) =>
      fields.some((field) => errorField.startsWith(field))
    )?.[0] || null
  );
};

/**
 * Handles navigation to a new step in a multi-step form.
 * Validates the current step's fields before allowing navigation.
 * If validation passes, updates the current page and latest completed step.
 * If validation fails, shows an error snackbar.
 *
 * @param {object} formik - The Formik instance for form state management.
 * @param {string[]} currentStepFields - Array of field paths to validate for the current step.
 * @param {number} newPage - The index of the step to navigate to.
 * @param {function} setPage - Function to update the current page.
 * @param {function} setLatestStepCompleted - Function to update the latest completed step.
 * @param {function} handleOpenSnackbar - Function to show an error message.
 */
export const handleNewStepClick = async (
  formik,
  currentStepFields,
  newPage,
  setPage,
  setLatestStepCompleted,
  handleOpenSnackbar
) => {
  if (await pageFormValidation(formik, currentStepFields)) {
    setPage(newPage);
    setLatestStepCompleted((prev) => Math.max(prev, newPage));
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    handleOpenSnackbar("Fix all errors before changing steps");
  }
};
